<template>
  <nav
    :aria-label="labels.sidor"
    v-bind:aria-labelledby="id && id.length > 0 ? id : null"
  >
    <ul v-if="pager.pages && pager.pages.length" class="pagination ps-0">
      <li v-if="pager.currentPage > 1" class="page-item previous">
        <a
          class="page-link"
          v-on:click.prevent="setPage(pager.currentPage - 1)"
          :href="getUrl(pager.currentPage - 1)"
          rel="prev"
          >{{ labels.foregaende }}</a
        >
      </li>
      <li
        v-for="page in pager.pages"
        :key="page"
        class="page-item page-number"
        :class="{ active: pager.currentPage === page }"
      >
        <span
          v-if="pager.currentPage === page"
          aria-current="page"
          :aria-label="labels.aktuellSida + ' ' + page"
          class="page-link"
          >{{ page }}</span
        >
        <a
          v-else
          class="page-link"
          :aria-label="labels.gaTillSida + ' ' + page"
          v-on:click.prevent="setPage(page)"
          :href="getUrl(page)"
          >{{ page }}</a
        >
      </li>
      <li v-if="pager.currentPage !== pager.totalPages" class="page-item next">
        <a
          class="page-link"
          v-on:click.prevent="setPage(pager.currentPage + 1)"
          :href="getUrl(pager.currentPage + 1)"
          rel="next"
          >{{ labels.nasta }}</a
        >
      </li>
    </ul>
  </nav>
</template>

<script>
import paginate from "jwPaginate";

var resizeObserver = undefined;
var resizeObserverElement = undefined;

export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
    },
    totalMatching: Number,
    initialPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    maxPages: {
      type: Number,
      default: 10,
    },
    maxPagesMd: {
      type: Number,
      default: 7,
    },
    maxPagesSm: {
      type: Number,
      default: 1,
    },
    url: {
      type: String,
      default: "?page=",
    },
    labels: {
      type: Object,
    },
  },
  data() {
    return {
      pager: {},
      breakpoints: {
        sm: parseInt(
          getComputedStyle(document.body).getPropertyValue("--bs-breakpoint-sm")
        ),
        md: parseInt(
          getComputedStyle(document.body).getPropertyValue("--bs-breakpoint-md")
        ),
      },
      maxPagesShown: this.maxPages,
      isMobileView: false,
    };
  },
  created() {
    // set to initial page
    let page = this.getPage();
    this.setPage(page, true);
  },
  mounted() {
    this.addEventListeners();
    this.handlePageResize();
  },
  unmounted() {
    this.removeEventListeners();
  },
  methods: {
    setPage(page, initial = false, popstate = false) {
      this.updatePager(page);

      if (!initial && !popstate) {
        // Update url
        if ("URLSearchParams" in window) {
          let title = document.getElementsByTagName("title")[0].innerText;
          let newUrl = new URL(
            window.location.pathname,
            window.location.origin
          );
          let searchParams = new URLSearchParams(window.location.search);
          searchParams.set("page", page);
          newUrl.search = searchParams.toString();
          history.pushState(null, title, newUrl);
        }
        // emit change page event to parent component
        this.$emit("changePage", page);
      }

      if (popstate) {
        // emit change page event to parent component
        this.$emit("changePage", page);
      }
    },
    updatePager(page) {
      const { items, totalMatching, pageSize } = this;

      // get new pager object for specified page
      const pager = paginate(totalMatching, page, pageSize, this.maxPagesShown);

      // Get new page of items from items array (if provided)
      if (items != undefined && items != null && items.length) {
        const pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);
        this.$parent.pagedResult = pageOfItems;
      }

      // update pager
      this.pager = pager;
    },
    getPage() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get("page") != null
        ? parseInt(urlParams.get("page"))
        : 1;
    },
    getUrl(page) {
      return this.url + page;
    },
    handlePageResize() {
      var maxPagesShown =
        window.innerWidth < this.breakpoints.sm
          ? this.maxPagesSm
          : window.innerWidth < this.breakpoints.md
          ? this.maxPagesMd
          : this.maxPages;

      maxPagesShown =
        maxPagesShown > this.maxPages ? this.maxPages : maxPagesShown;
      if (this.maxPagesShown != maxPagesShown) {
        this.maxPagesShown = maxPagesShown;
        this.updatePager(this.getPage());
      }
    },
    addEventListeners() {
      this.removeEventListeners();
      resizeObserver = new ResizeObserver(() => this.handlePageResize());
      resizeObserverElement = document.body;
      resizeObserver.observe(resizeObserverElement);
    },
    removeEventListeners() {
      if (resizeObserver && resizeObserverElement) {
        resizeObserver.unobserve(resizeObserverElement);
        resizeObserver.disconnect();
      }
    },
  },
  watch: {
    items() {
      this.setPage(this.initialPage);
    },
  },
};
</script>
